// eslint-disable-next-line import/no-anonymous-default-export
export default {
  header: {
    input: "Пошук",
    login: "Увійти",
  },
  hotBar: {
    home: "ГОЛОВНА",
    shop: "МАГАЗИН",
    buyers: "ПОКУПЦЯМ",
    blog: "БЛОГ",
    contacts: "КОНТАКТИ",
    menu: "Meню",
    languages: "Мова",
  },
  intro: {
    text: "Революційна система трьох камер - набагато більше можливостей та незмінна простота у використані",
    btn: "До каталогу",
  },
  category: {
    title: "Категорії магазину",
  },
  discount: {
    title: "ЗНИЖКИ НА АКСЕСУАРИ",
    btn: "Переглянути",
  },
  catalog: {
    title: "Каталог товарів",
  },
  product: {
    btn: "Придбати",
  },
  blog: {
    title: "Блог",
    titlecard1: "Сучасна камера",
    titlecard2: "Сервіс онлайн музики",
    titlecard3: "Слідкуйте за вашим здоров'ям",
    text1: "Робіть неймовірні фото з оновленою камерою на 12 МП",
    text2: "Слухайте музику де вам зручно в новому додатку",
    text3: "На прогулянці, на роботі, завжди на контролі вашого стану",
    details: "Детальніше",
  },
  footer: {
    follow: "Ми в соціальних мережах",
  },
};
